import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Grid, Box, Paper, Button, Typography, TextField, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem, ListItemText, makeStyles } from '@material-ui/core';
import CardWitTitle from './CardWithTitle';
import SecretInput from './SecretInput';
import UserInfoCopy from './UserInfoCopy';
import MembershipDateSelector from './MembershipDateSelector';
import validatePersonalId from '../utilities/validatePersonalId';
import validateLmaNumber from '../utilities/validateLmaNumber';
import validateBirthDate from '../utilities/validateBirthDate';
import memberCategories from '../data/memberCategories';
const personnummer = require('personnummer.js');

function ApplicationPersonalInfo({ type, submission, storeGroups, onChange, usersWithSamePersonalId, setUsersWithSamePersonalId, approvalToggle, ...props }) {

  // useEffect(() => {
  //   if (typeof submission.approvePersonalInfo === 'undefined') {
  //     const _submission = {
  //       ...submission,
  //       approvePersonalInfo: false,
  //     };
  //     onChange(_submission);
  //   }
  // }, []);

  const handleChange = (event) => {
    // console.log(event.target.name);
    const name = event.target.name;
    let key = null;
    let value = event.target.value;
    switch (name) {
      case 'first-name':
        key = 'firstName';
        break;
      case 'last-name':
        key = 'lastName';
        break;
      case 'has-no-personal-id':
        key = 'hasNoPersonalId';
        value = event.target.checked;
        break;
      case 'personal-id':
        key = 'personalId';
        break;
      case 'lma-number':
        key = 'lmaNumber';
        break;
      case 'birth-date':
        key = 'birthDate';
        break;
      case 'member-category':
        key = 'memberCategory';
        break;
      case 'store-group-id':
        key = 'storeGroupRef';
        const storeGroup = storeGroups?.find(storeGroup => storeGroup.id === value);
        value = storeGroup.ref;
        break;
      case 'district':
        key = 'district';
        break;
      case 'notes':
        key = 'notes';
        break;
      case 'membership-active':
        key = 'membershipActive';
        value = event.target.checked;
        break;
      case 'membership-expiration-timestamp':
        key = 'membershipExpirationTimestamp';
        break;
      case 'approve-personal-info':
        key = 'approvePersonalInfo';
        value = event.target.checked;
        break;
      default:
        break;
    }
    const _submission = {
      ...submission,
      [key]: value,
    };
    onChange(_submission);
  };





  const submissionStoreGroup = () => {
    const storeGroup = storeGroups?.find(storeGroup => storeGroup.ref.isEqual(submission?.storeGroupRef ? submission.storeGroupRef : null));
    return storeGroup;
  };

  const handleUserWithSamePersonalIdResetChange = (index) => {
    const list = usersWithSamePersonalId.map((user, i) => {
      if (i === index) {
        user.reset = !user.reset;
      }
      return user;
    });
    setUsersWithSamePersonalId([...list]);
  };

  const handleValidatePersonalId = () => {
    return validatePersonalId(submission);
  };

  const handleValidateLmaNumber = () => {
    return validateLmaNumber(submission?.lmaNumber, submission?.birthDate);
  };

  const handleValidateBirthDate = () => {
    return validateBirthDate(submission?.birthDate, submission?.lmaNumber);
  };

  const useStyles = makeStyles(theme => ({
    photo: {
      width: '100%',
      padding: 20
    },
    input: {
      marginTop: 30,
    },
    formControl: {
      marginTop: 30,
      width: '100%',
    },
    inputFirst: {
      marginTop: 0,
    },
    box: {
      textAlign: 'left',
      marginTop: 30,
    }
  }));

  const classes = useStyles();

  return (
    <React.Fragment>
      <CardWitTitle
        title="Personlig information"
        onChange={approvalToggle && handleChange}
        checked={submission?.approvePersonalInfo}
        name='approve-personal-info'>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField label="Förnamn" name='first-name' variant='outlined' fullWidth
              className={`${classes.input} ${classes.inputFirst}`}
              value={submission?.firstName} onChange={handleChange} />
            <TextField label="Efternamn" id='last-name' name='last-name' variant='outlined' fullWidth className={classes.input} value={submission?.lastName} onChange={handleChange} />

            {type !== 'membership-application' &&
              <>
                {/* <Typography
                  variant="body2"
                  component="h6"
                  color="primary"
                  style={{ textAlign: 'left', marginTop: 30, marginBottom: 0 }}
                >
                  Personnummer
                </Typography> */}
                <FormControlLabel
                  style={{ display: 'flex', marginBottom: 10 }}
                  className={classes.formControl}
                  control={
                    <Checkbox
                      checked={submission?.hasNoPersonalId}
                      onChange={
                        handleChange
                      }
                      name='has-no-personal-id'
                      color='primary'
                    />
                  }
                  label="Personnummer saknas"
                />
              </>
            }

            <Box className={`${classes.input} ${type !== 'membership-application' && classes.inputFirst}`}>
              <SecretInput
                label="Personnummer"
                name='personal-id'
                value={submission?.personalId}
                onChange={handleChange}
                error={!handleValidatePersonalId()}
                helperText={!handleValidatePersonalId() ? "Personnummer ej giltigt" : null}
                ariaLabel="Växla synlighet av personnummer"
                disabled={submission?.hasNoPersonalId}
              />
            </Box>

            {usersWithSamePersonalId?.length > 0 &&
              <Box className={classes.box}>
                <Typography>
                  Angivet personnummer finns redan registrerat på annat användarkonto.
                </Typography>
                {usersWithSamePersonalId.map(
                  (altUser, index) => {
                    return (
                      <UserInfoCopy
                        altUser={altUser}
                        handleChange={(event) => {
                          handleUserWithSamePersonalIdResetChange(
                            index
                          );
                        }}
                        label={
                          "Flytta personnummer"
                        }
                        enforceApproval={type === 'membership-overview'}
                        key={altUser.id}
                      />
                    );
                  }
                )}
              </Box>
            }

            {
              type !== 'membership-application' &&
              <>
                <Typography
                  variant="body2"
                  component="h6"
                  color="primary"
                  style={{ textAlign: 'left', marginTop: 40, marginBottom: 20 }}
                >
                  LMA-kort
                </Typography>
                <Grid container style={{ marginBottom: 0 }} spacing={2}>
                  <Grid item xs={6}>
                    <TextField
                      onChange={handleChange}
                      error={
                        // didTryToSave &&
                        !handleValidateLmaNumber()
                      }
                      name='lma-number'
                      value={submission?.lmaNumber}
                      label="LMA-nummer, åtta siffror"
                      helperText={
                        // didTryToSave &&
                        !handleValidateLmaNumber() &&
                        "LMA-nummer anges med åtta siffror utan bindestreck"
                      }
                      variant="outlined"
                      // disabled={hasNoPersonalId}
                      style={{ width: '100%' }}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      onChange={handleChange}
                      error={
                        // didTryToSave &&
                        !handleValidateBirthDate()
                      }
                      name='birth-date'
                      value={submission?.birthDate}
                      label="Födelsedatum, ÅÅMMDD"
                      helperText={
                        // didTryToSave &&
                        !handleValidateBirthDate() &&
                        "Födelsedatum anges med 6 siffror utan bindestreck"
                      }
                      variant="outlined"
                      // disabled={hasNoPersonalId}
                      style={{ width: '100%' }}
                    />
                  </Grid>
                </Grid>
              </>
            }

            <Typography
              variant="body2"
              component="h6"
              color="primary"
              style={{ textAlign: 'left', marginTop: 40, marginBottom: 20 }}
            >
              Övrigt
            </Typography>
            <FormControl
              variant="outlined"
              className={`${classes.formControl} ${classes.inputFirst}`}
            >
              <InputLabel id='category-label'>
                Kategori
              </InputLabel>
              <Select
                multiple
                labelId='category-label'
                name='member-category'
                value={
                  typeof submission?.memberCategory !== 'undefined'
                  && Array.isArray(submission.memberCategory)
                  ? submission.memberCategory 
                  : []
                }
              onChange={
                handleChange
              }
              label="Kategori"
              renderValue={(selected) => selected.join(', ')}
              MenuProps={{
                // Material-UI workaround to avoid 
                // multiselect popup anchor moving on select.
                getContentAnchorEl: () => null,
              }}
              >
              {memberCategories.map(
                (category) => {
                  return (
                    <MenuItem
                      value={category}
                      key={category}
                    >
                      <Checkbox
                        color='primary'
                        checked={
                          typeof submission?.memberCategory !== 'undefined'
                          && Array.isArray(submission.memberCategory)
                          && submission.memberCategory.indexOf(category) > -1
                        }
                      />
                      <ListItemText primary={category} />
                    </MenuItem>
                  );
                }
              )}
            </Select>
            {/* <Button
                variant='text'
                color='primary'
                onClick={() => handleChange({
                  target: {
                    name: 'member-category',
                    value: [],  
                  }
                })}
              >
                Rensa kategori
              </Button> */}

          </FormControl>


          <FormControl className={classes.formControl} fullWidth variant='outlined'>
            <InputLabel id='store-group-label'>Butiksgrupp</InputLabel>
            <Select labelId='store-group-label' label="Butiksgrupp" id='store-group'
              value={submissionStoreGroup()?.id ? submissionStoreGroup().id : ""}
              name='store-group-id'
              onChange={handleChange}
              error={!submissionStoreGroup()}
              >
              {storeGroups?.map(storeGroup => (
                <MenuItem value={storeGroup.id} key={storeGroup.id}>{storeGroup.name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl className={classes.formControl} fullWidth variant='outlined'>
            <InputLabel id='district-label'>Område</InputLabel>
            <Select labelId='district-label' label="Område" id='district'
              value={submission?.district}
              name='district'
              onChange={handleChange}>
              {submissionStoreGroup() ? submissionStoreGroup().districts?.map(district => (
                <MenuItem value={district} key={district}>{district}</MenuItem>
              )) : null}
            </Select>
            <Button
              variant='text'
              color='primary'
              onClick={() => handleChange({
                target: {
                  name: 'district',
                  value: "",
                }
              })}
            >
              Rensa område
            </Button>
          </FormControl>

          {
            type !== 'membership-application' &&
            <>
              <TextField
                multiline
                rows={4}
                onChange={handleChange}
                name='notes'
                value={submission?.notes}
                label="Anteckningar"
                variant='outlined'
                style={{ width: '100%', marginTop: 30 }}
              />
              <MembershipDateSelector
                membershipActive={submission?.membershipActive}
                membershipExpirationTimestamp={submission?.membershipExpirationTimestamp}
                onChange={handleChange}
              />
            </>
          }

        </Grid>
      </Grid>
    </CardWitTitle>
    </React.Fragment >
  );
}



export default ApplicationPersonalInfo;